import store from '@/app/store/store';
import { activeAppStatus } from '@/app/utils/app/app';


export function hasAppSubscription(to, from, next) {
  if (to.matched.some(record => record.meta.requiresSubscription)) {
    const requiredApp = store.getters['app/activeApps'].filter(app => app.appName === to.meta.app)[0];
    if (requiredApp && activeAppStatus.includes(requiredApp.status)) {
      next();
    } else {
      next({
        path: '/',
      });
    }
  } else {
    next();
  }
}

export function hasAppPermission(to, from, next) {
  if (to.matched.some(record => record.meta.requiresPermission)) {
    const requiredApp = store.getters['app/activeApps']
      .filter(app => app.appName === to.meta.app)[0];
    const hasPermission = to.meta?.permission
      ? requiredApp.permission === to.meta.permission
      : true;
    if ((requiredApp && hasPermission)) { // User has permission to an active app
      store.dispatch('app/setActiveApp', requiredApp.appName);
      next();
    } else if (store.getters['toolkit/getItem'].grant_type === 'SHARE') {
      store.dispatch('app/setActiveApp', 'TOOLKIT');
      next();
    } else { // app doesn't exist
      store.dispatch('app/setActiveApp', 'HOME');
      next({ path: '/' });
    }
  } else {
    if (to.meta.app) {
      store.dispatch('app/setActiveApp', to.meta.app);
    } else {
      store.dispatch('app/setActiveApp', null);
    }
    next();
  }
}

export function hasActiveToolkitSubscription(to, from, next) {
  if (to.name === 'subscribe') {
    if (store.getters['account/hasAppSubscription']('TOOLKIT')) {
      next({ path: '/account' });
    } else {
      next();
    }
  } else {
    next();
  }
}
